import { Component, ReactNode } from 'react';

interface OutsideClickComponentProps {
    className?: string;
    onClickedOutside: () => void;
    children: ReactNode;
}

export class OutsideClickComponent extends Component<OutsideClickComponentProps> {
    private wrapperRef: HTMLDivElement | null = null;

    constructor(props: OutsideClickComponentProps) {
        super(props);

        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    public componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    public componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    public handleClickOutside(event: Event): void {
        if (event.target instanceof HTMLElement && this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.props.onClickedOutside();
        }
    }

    public render(): ReactNode {
        return (
            <div
                className={this.props.className}
                ref={(wrapperRef) => {
                    this.wrapperRef = wrapperRef;
                }}
            >
                {this.props.children}
            </div>
        );
    }
}
